module.exports = "<app-area-edit-general area=$ctrl.area on-change=$ctrl.setDirty() on-valid-change=$ctrl.setValid(valid)> </app-area-edit-general> ";


//////////////////
// WEBPACK FOOTER
// /app/suissealpine/static/app/area/edit/general/template.html
// module id = 403
// module chunks = 0